module.exports = __webpack_public_path__ + "static/media/YF95_1.d68d3fcb.jpg";